import React, { Component } from 'react';
import Post from './Post';
import Video from './Video';

import './css/Modal.css';
import './css/Post.css';

class Modal extends Component {
    constructor(props) {
        super(props);
        this.timer = null;
        this.state = {
            active: false, 
            destoryFlickity: false
        }; 
        this.closeModal = this.closeModal.bind(this);
        this.endOfImages = this.endOfImages.bind(this);
        this.bgStyle = this.bgStyle.bind(this);
    }

    componentDidUpdate(){
        if (this.state.destoryFlickity) {
            this.setState({ destoryFlickity: false});
        }
    }

    closeModal(){   
        this.setState({ active: !this.state.active });
        this.props.modalHandler(false);
        
        if(this.timer){
            clearTimeout(this.timer);
        }
    }


    endOfImages(cancelTime) {
        if(cancelTime){
            if(this.timer){
                clearTimeout(this.timer);
            }   
        } else {
            let that = this;
            this.timer = setTimeout(function(){
                that.setState({ active: !that.state.active, destoryFlickity: true});
                that.props.modalHandler(true);
            },3000);
            //load 2 of nxt post images
            if(this.props.nextPost.fields.imageGallery !== 'undefined' && typeof this.props.nextPost.fields.imageGallery !== 'undefined'){
                for(var i = 0; i < 2; i++) {
                    const img = new Image();
                    img.src = this.props.nextPost.fields.imageGallery[i].fields.file.url+'?q=90&w=1400';
                }
            }
        }
    }
    
    bgStyle(){
        if(this.props.fields.backgroundColour !== undefined){
            return {
                background: this.props.fields.backgroundColour
            }
        } else {
            return {
                background: '#FFFFFF'
            }
        }  
    }

    render() {
        return (
        <div className={this.state.active ? 'modal': 'modal'} style={this.bgStyle()}>
            { this.props.fields.imageGallery !== 'undefined' && typeof this.props.fields.imageGallery !== 'undefined' && !this.state.destoryFlickity ? <Post postName={this.props.fields.title} postCat={this.props.fields.category} images={this.props.fields.imageGallery} endOfPostHandler={this.endOfImages} currentPost={this.props.currentPost} totalPosts={this.props.totalPosts} /> : null }
            { this.props.fields.video !== 'undefined' && typeof this.props.fields.video !== 'undefined' ? <Video postName={this.props.fields.title} postCat={this.props.fields.category} video={this.props.fields.video} endOfPostHandler={this.endOfImages} currentPost={this.props.currentPost} /> : null }
            <button type="button" onClick={this.closeModal} className="backBtn"><span className="menuTriggerInner">Close</span></button>
        </div>
        );
    }
    componentWillUnmount(){
        if(this.timer){
            clearTimeout(this.timer);
        }
    }
}

export default Modal;


// WEBPACK FOOTER //
// ./src/Modal.js